/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-fd3498b6.js';
import { useEffect } from 'react';
import '../../_chunks/dep-2acfafca.js';

var dialogSet = /* @__PURE__ */new Set();
var useDialogEsc = function useDialogEsc(visible, dialog) {
  useEffect(function () {
    if (visible) {
      if (dialog !== null && dialog !== void 0 && dialog.current) {
        var _dialog$current;
        dialogSet.add(dialog);
        dialog === null || dialog === void 0 ? void 0 : (_dialog$current = dialog.current) === null || _dialog$current === void 0 ? void 0 : _dialog$current.focus();
      }
    } else if (dialogSet.has(dialog)) {
      var _dialogList, _dialogList$current;
      dialogSet["delete"](dialog);
      var dialogList = _toConsumableArray(dialogSet);
      (_dialogList = dialogList[dialogList.length - 1]) === null || _dialogList === void 0 ? void 0 : (_dialogList$current = _dialogList.current) === null || _dialogList$current === void 0 ? void 0 : _dialogList$current.focus();
    }
    return function () {
      dialogSet.forEach(function (item) {
        if (item.current === null) {
          dialogSet["delete"](item);
        }
      });
    };
  }, [visible, dialog]);
};

export { useDialogEsc as default };
//# sourceMappingURL=useDialogEsc.js.map
